import { atom } from "recoil";

export const jobIdState = atom({
  key: "jobIdState",
  default: "",
});
